// Função utilitária para formatar valores monetários em Real (BRL)
export const formatarValor = (valor) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(valor);
};

